import { ButtonBase, Container, delayedCall, dispatcher, IEvent, ingenuity, IObject, Meter, SpineBase } from "@quest/base-core";
import { HoldAndRespinModel } from "../Model/HoldAndRespinModel";
import { HoldAndRespinView } from "../View/HoldAndRespinView";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { GameParserModel } from "../../Platform/GameParserModel";
import { SoundConstantGame } from "../../Constants/SoundConstantGame";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist/Game/BehaviorConstants/SlotConstantsBehavior";
import { SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";

export class HoldAndReSpinController {

    protected view: HoldAndRespinView;
    protected model: HoldAndRespinModel;
    protected jackpotWhaleContainer: Container;
    protected anticipationsCont: Container;
    protected jackpotWhaleSpine: SpineBase;

    constructor(view: HoldAndRespinView, model: HoldAndRespinModel) {
        this.view = view;
        this.model = model;
        (this.view.getMeterById("jackpotMtr") as Meter).setCurrencyFormattedValue((ingenuity.parserModel.getCurrentTotalBet() * ingenuity.configData.fixedJackpotAmount).toString());
        this.view.getContainerByID("jpContAllign").pivot.set(this.view.getContainerByID("jpContAllign").width / 2, 0);
        (this.view.getButtonById("CollectionScreenBtn") as ButtonBase).disableAndTint();
        this.initializeElements();
        this.subscribeEvents();
    }
    private initializeElements(): void {
        this.jackpotWhaleContainer = this.view.getContainerByID("jackpotWhaleContainer");
        this.jackpotWhaleSpine = this.view.getSpineById("jackpotWhale");
        this.anticipationsCont = this.view.getContainerByID("AnticipationReelsContainer");
    }
    private subscribeEvents(): void {
        this.unSubscribeEvents();
        dispatcher.on(eventDispatchers.SHOW_SYMBOL_ON_REEL, this.showSymbolOnReel, this)
        dispatcher.on(eventDispatchers.STOP_INITIAL_SYM_APPEREARED_REEL, this.stopInitialAppearedReel, this)
        dispatcher.on(eventDispatchers.PLAY_MOVING_BAIT_IDLE, this.playMovingBaitAnim, this)
        dispatcher.on(eventDispatchers.STOP_JP_BUBBLES, this.stopBubbleBehindJackpot, this)
        dispatcher.on(eventDispatchers.SHOW_JP_PRESENTATION, this.playWhaleIntro, this);
        dispatcher.on(eventDispatchers.PLAY_ANTICIPATION_ON_TV_REELS, this.playAnticipationAnimation, this);
        dispatcher.on(eventDispatchers.REMOVE_ANTICIPATION_CONT, this.removeContainer, this);
        
    }
    private unSubscribeEvents(): void {
        dispatcher.off(eventDispatchers.SHOW_SYMBOL_ON_REEL, this.showSymbolOnReel, this)
        dispatcher.off(eventDispatchers.STOP_INITIAL_SYM_APPEREARED_REEL, this.stopInitialAppearedReel, this);
        dispatcher.off(eventDispatchers.PLAY_MOVING_BAIT_IDLE, this.playMovingBaitAnim, this);
        dispatcher.off(eventDispatchers.STOP_JP_BUBBLES, this.stopBubbleBehindJackpot, this)
        dispatcher.off(eventDispatchers.SHOW_JP_PRESENTATION, this.playWhaleIntro, this);
        dispatcher.off(eventDispatchers.PLAY_ANTICIPATION_ON_TV_REELS, this.playAnticipationAnimation, this);
        dispatcher.off(eventDispatchers.REMOVE_ANTICIPATION_CONT, this.removeContainer, this);

    }
    private playBubbleBehindJackpot(): void {
        const JPBubbleAnim = this.view.getSpineById("jackpot_meter_glow");
        JPBubbleAnim.visible = true
        JPBubbleAnim.setPause(false);
        JPBubbleAnim.playAnim("in", false);
        JPBubbleAnim.onComplete.addOnce(() => {
            JPBubbleAnim.playAnim("loop", true);

        });
    }
    private stopBubbleBehindJackpot(): void {
        const JPBubbleAnim = this.view.getSpineById("jackpot_meter_glow");
        JPBubbleAnim.playAnim("out", false);
        JPBubbleAnim.onComplete.addOnce(() => {
            JPBubbleAnim.visible = false
            JPBubbleAnim.setPause(true);
            JPBubbleAnim.onComplete.dispose()
        });
    }
    /**
     * function will show initially apperaed symbols as sticky and stop the reels spinnning 
     * also fade the non NUT symbols
     */
    private stopInitialAppearedReel(): void {
        this.model.getInitialPositions().forEach((position: number) => {
            this.playLockAnimation(this.view.getReelView().getSymbolByPos(position, 0), false);
            this.model.setStoppedReels(position);
        })
    }
    /**
     * function will show sticky reel with lock animation and stop that reel's spinning
     */
    private showSymbolOnReel(evt: IEvent): void {
        this.removeAnticipation(evt.data)
        if ((ingenuity.parserModel as GameParserModel).getHnRStoppingReelGrid()[evt.data]) {
            this.model.setStoppedReels(evt.data);
            this.playLockAnimation(this.view.getReelView().getSymbolByPos(evt.data, 0), true);
            const symbolNum = this.view.getReelView().getSymbolByPos(evt.data, 0).symNum;
            if (symbolNum === 1) {
                (ingenuity.soundManager as any).playSound(SoundConstantGame.LL_ICON_APPEAR_SIMPLE_1, 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);

            }
            else if (symbolNum === 2) {

                (ingenuity.soundManager as any).playSound(SoundConstantGame.LL_ICON_APPEAR_SIMPLE_2, 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);

            }
            else if (symbolNum === 4) {
                (ingenuity.soundManager as any).playSound(SoundConstantGame.LL_ICON_APPEAR_MAX_1, 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);

            }
            else if (symbolNum === 3) {
                (ingenuity.soundManager as any).playSound(SoundConstantGame.LL_ICON_APPEAR_MAX_2, 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
            }
        }
    }
    /**
     * to play nut locking animation
     */
    private playLockAnimation(symbol: any, playLanding: boolean): void {
        const staticSym = symbol.getStatic();
        const animSym = symbol.getAnimation();
        if (animSym) {
            const staticSymParent = staticSym.parent;
            if (staticSymParent) {
                staticSym.visible = true;
                animSym.visible = true;
                animSym.setPause(false);
                staticSymParent.addChild(animSym);
                const anim = animSym.json.animations.anim ? animSym.json.animations.anim : "anim";
                const landing = animSym.json.animations.landing ? animSym.json.animations.landing : "landing";
                setTimeout(() => {
                    if (playLanding) {
                        animSym.playAnim(landing, false);
                        animSym.onComplete.addOnce(() => {
                            animSym.playAnim(anim, true);
                        }, this);
                    } else {
                        animSym.playAnim(anim, true);
                    }
                }, 10);
            }
        }
    }
    /**
     * to show moving symbol for auto pilot bait
     */
    private playMovingBaitAnim(evt: IEvent): void {
        this.playLockAnimation(this.view.getReelView().getSymbolByPos(evt.data, 0), false);
    }
    /**to play whale on filled TV reels */
    private playWhaleIntro(evt: IEvent): void {
        const soundObj: IObject = { id: SoundConstantGame.WHALE_SPAWN, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD };
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, soundObj);
        this.jackpotWhaleSpine.setPause(false);
        this.jackpotWhaleContainer.visible = true;
        this.jackpotWhaleSpine.visible = true;
        this.playBubbleBehindJackpot();
        this.jackpotWhaleSpine.playAnim("intro", false);
        this.jackpotWhaleSpine.onComplete.addOnce(() => {
            this.jackpotWhaleSpine.playAnim("idle", true);
            delayedCall("whaleOutroDelay", 1000, () => {
                dispatcher.fireEvent(eventDispatchers.HIDE_TOP_LOGO_ON_BANNER);
                this.jackpotWhaleSpine.visible = false;
                this.jackpotWhaleSpine.setPause(true);
                dispatcher.fireEvent(eventDispatchers.SHOW_JACKPOT_BANNER);

            });
        });
    }
    private playAnticipationAnimation(evt: IEvent): void {
        const row: number = this.model.getPosToOffset(evt.data)[0]
        const col: number = this.model.getPosToOffset(evt.data)[1]
        const anticipation: SpineBase = this.view.createSpineAnimation("anticipationAnim");
        const AnticipationCont: Container = this.view.createContainerClone("anticipationContainer");
        AnticipationCont.addChild(anticipation)
        anticipation.setPause(false)
        anticipation.playAnim((anticipation.json as any).animName, true)
        AnticipationCont.x = row * this.view.json.symWidth;
        AnticipationCont.y = col * this.view.json.symHeight;
        (AnticipationCont as any).id = this.view.json.anticipationContainer.name + "_" + evt.data;
        this.anticipationsCont.addChild(AnticipationCont);
    }
    private removeAnticipation(reelID: number): void {
        this.anticipationsCont.children.forEach((child: any) => {
            if ((child.id === "anticipationContainer_" + reelID)) {
                child.children[0]?.setPause(true);
                child.children[0]?.destroy();
                child.removeChildren();
                child.children = [];
            }
        });
    }
    private removeContainer(): void {
        this.anticipationsCont.removeChildren();
        this.anticipationsCont.children = [];
    }
    /**
     * reset feature
     */
    public resetController(): void {
        this.removeContainer();
        this.unSubscribeEvents();
    }


}